
import { defineComponent, ref } from "vue";
import jsPDF from "jspdf";
export default defineComponent({
  name: "invoice-default",
  props: {
    invoice: Object,
  },
  setup() {
    const root = ref();
    const printing = ref(false);
    const createPDF = () => {
      var doc = new jsPDF("l", "mm", [1200, 1210]);
      printing.value = true;
      doc.html(root.value, {
        callback: function (doc) {
          printing.value = false;
          doc.save("output.pdf");
        },
        x: 0,
        y: 0,
      });
    };
    return {
      createPDF,
      root,
      printing,
    };
  },
});
